import { AVAILABILITY_TYPE_IN_OFFICE_OR_VIRTUAL } from '@/views/constants'
export default class TimeBlock {
  static formatTime (time) {
    const timeParts = time.split(':')

    const hour = parseInt(timeParts[0])
    const minute = parseInt(timeParts[1])
    let formattedHour

    if (hour === 0) {
      formattedHour = '12'
    } else if (hour > 12) {
      formattedHour = (hour - 12).toString()
    } else {
      formattedHour = hour.toString()
    }

    const formattedMinute = minute < 10 ? `0${minute}` : minute.toString()
    const meridiem = hour >= 12 ? 'PM' : 'AM'

    return `${formattedHour}:${formattedMinute} ${meridiem}`
  }

  static getExternalReasonIdsList (idsStr) {
    const idsList = typeof idsStr === 'string' && idsStr ? idsStr.split(',') : []
    return (idsList).filter(id => !!id)
  }

  constructor (options = {}) {
    this.id = options.id || null
    this.date = options.date || null
    this.startTime = options.start_time || null
    this.formattedStartTime = options.start_time ? TimeBlock.formatTime(options.start_time) : null
    this.duration = options.duration || null
    this.state = options.state || null
    this.availabilityType = options?.availability_type ?? AVAILABILITY_TYPE_IN_OFFICE_OR_VIRTUAL
    this.externalReasonIds = TimeBlock.getExternalReasonIdsList(options?.external_reason_ids || null)
  }
}
